import { render, staticRenderFns } from "./OldShop.vue?vue&type=template&id=d3a65dba&"
import script from "./OldShop.vue?vue&type=script&lang=js&"
export * from "./OldShop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports